import { useEffect, useRef } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  fetchAnswersBySession,
  fetchResultsBySession,
} from "../Features/Sessions/Actions/SessionsActions";

const RequireFail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const sessionId = parseInt(id);
  const mounted = useRef(null);

  const { result, error, answers } = useSelector((store) => store.sessions);

  useEffect(() => {
    mounted.current = true;
    if (error) return;
    if (mounted.current && !result && !answers) {
      dispatch(fetchAnswersBySession(sessionId)).then(() =>
        dispatch(fetchResultsBySession(sessionId)),
      );
    }
    return () => (mounted.current = false);
  }, [error, sessionId]);

  result ? console.log("result PRESENT") : console.log("result ABSENT");

  // conditional should be (result && !error)
  return result ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};

export default RequireFail;
